/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const overviewSortSchema = z.enum(['created_at', 'name', 'candidates', 'hires', 'cost_per_candidate'])

export type OverviewSortSchema = z.infer<typeof overviewSortSchema>
